import $ from 'jquery';

const navToggle = () => {
  $( '.nav' ).toggleClass( 'open' )
  $( 'body' ).toggleClass( 'no-scroll' )
  $( '.menu-dropdown' ).css( 'max-height', '' );
}

const dropdownToggle = ( link ) => {
  $( link ).siblings().removeClass( 'show' )
  $( link ).toggleClass( 'show' )
  $( '.dropdown-1' ).hasClass( 'show' ) ? $( '.nav' ).addClass( 'dropdown-active' ) : $( '.nav' ).removeClass( 'dropdown-active' )
}

$( window ).on( 'load', () => {
  $( '.nav' ).addClass( 'active' )
  $( '.nav-handle' ).on( 'click', () => {
    navToggle()
  } )
});

$( window ).on( 'resize', () => {
  $( '.nav' ).hasClass( 'open' ) ? navToggle() : '';
  $( '.dropdown-1' ).hasClass( 'show' ) ? $( '.dropdown-1' ).removeClass( 'show' ) : '';
});

$( '.dropdown-1 .dropdown-button' ).on( 'click', function() {
  dropdownToggle( $( this ).parent() )
} )

$( 'main' ).on( 'click', () => {
  $( '.dropdown-1' ).removeClass( 'show' )
  $( '.nav' ).removeClass( 'dropdown-active' )
} )

let position = $( window ).scrollTop(); 
let navHeight = $( '.nav' ).height();
let heroHeight = $( '.hero' ).height() + navHeight;
// should start at 0

$( window ).on( 'scroll', () => {
  let scroll = $( window ).scrollTop();
  //if the user scrolls past the navigation height, adds position fixed 
  // and translates the menu -100%;
  if ( scroll >= navHeight ) { 
    $( '.nav' ).addClass( 'nav-fix' );
  } else {
    $( '.nav' ).removeClass( 'nav-fix' );
  }
  // when the user scrolls page the hero, adds a nav-animate class so 
  // the fixed nav can now animate
  if( scroll > position || scroll <= navHeight) { 
    $( '.nav' ).removeClass( 'nav-animate' );
  } else {
    $( '.nav' ).addClass( 'nav-animate' );
  }

  position = scroll;

  // when the user makes an upwards scroll the nav translates to 0% 
  // if it has the nav-animate class also
  if ( scroll >= heroHeight ) {
    $( '.nav' ).addClass( 'nav-show' );
  } else {
    $( '.nav' ).removeClass( 'nav-show' );
  }
});

// Mobile Nav Accordion
$( document ).on( 'click', '.open .menu-item .dropdown-button', function( e ) {
  e.preventDefault();

  let $this = $( this );
  let $accordion = $this.parent();
  let $content = $this.next();

  $accordion.parent().find( '.menu-dropdown' ).css( 'max-height', '0' );

  if ($accordion.hasClass( 'open' ) ) {
    $accordion.removeClass( 'open' );
    
  } else {
    $accordion.siblings().removeClass( 'open' );
    $accordion.addClass( 'open' );
    $content.css( 'max-height', $content[0].scrollHeight );
  }
});